module.exports = __webpack_public_path__ + "img/permissions.ae286490.svg";